import { createSlice } from '@reduxjs/toolkit';

interface CU03101State {
    storedInput?: any;
    toiletBathOptions: any[];
    laundryAreaOptions: any[];
    statusOptions: any[];
    roomlayoutDivOptions: any[];
    currentStep: number;
    disabledBTN: {
        one: boolean;
        two: boolean;
        three: boolean;
        four: boolean;
        five: boolean;
    };
}

const initialState: CU03101State = {
    toiletBathOptions: [],
    laundryAreaOptions: [],
    statusOptions: [],
    roomlayoutDivOptions: [],
    currentStep: 1,
    disabledBTN: {
        one: true,
        two: true,
        three: true,
        four: true,
        five: true,
    },
};

export const CU03101Slice = createSlice({
    name: 'CU03101Slice',
    initialState,
    reducers: {
        setStoredInput: (state, action) => {
            state.storedInput = action.payload;
        },
        setToiletBathOptions: (state, action) => {
            state.toiletBathOptions = action.payload;
        },
        setLaundryAreaOptions: (state, action) => {
            state.laundryAreaOptions = action.payload;
        },
        setRoomlayoutDivOptions: (state, action) => {
            state.roomlayoutDivOptions = action.payload;
        },
        setStatusOptions: (state, action) => {
            state.statusOptions = action.payload;
        },
        setCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        setDisabledBTN: (state, action) => {
            state.disabledBTN = action.payload;
        },
        resetCU03101Slice: () => initialState,
    },
});

export const {
    setStoredInput,
    resetCU03101Slice,
    setToiletBathOptions,
    setLaundryAreaOptions,
    setRoomlayoutDivOptions,
    setStatusOptions,
    setCurrentStep,
    setDisabledBTN,
} = CU03101Slice.actions;

export default CU03101Slice.reducer;
